import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import http from '../../http'

export default function Token( props ) {
  const navigate = useNavigate()
  const params = useParams()

  useEffect( () => {
    http
      .post( `/api/auth/${ params.token }` )
      .then( response => {
        localStorage.setItem( 'token', response.data.token )
        navigate( '/board' )
      } )
      .catch( err => navigate( '/auth/login' ) )
  } )

  return (
    <label>
      { params.identity }
    </label>
  )
}
